export const environment = {
    production: false,
    apiURL: 'https://explorer-admin.dev.anddone.com',
    rootURI: '/',
    assetBaseHref: '/',
    merchantPortalURL:'https://portal.uat.anddone.com/#/forgot-password',
    strapiAUTH: '3d736458d4d87b6353d9a1a03b90db1c6efee7190931adc4b44f98dc671f3c8ddb63914fb289c4c198c658c38b82ea6b0d7b95972b762f4491038b158a162b26fc687d1a8f490efd2adc4536c9c23f611b9d38132c325116b5d524d3f52ad5ccbb2daba517c74c8e7ce2b1ccb282e876303ff5dfc5f41ec761a863a9f595643c',
    recaptchaKey: '6LfwpForAAAAAGUMly2nBIRoTGrw0VQa_t1VKlmu',
    enableFullStory: false,
    fullstoryOrgId: 'o-1ET0D4-na1',
    displayRecipes: true
};
